<template>
  <div>
    <div class="noprint">
      <AdminHeader></AdminHeader>
      <section class="admin-back">
        <div>
          <i class="fa fa-angle-left"></i>
          <router-link to="/admin/orderList">返回訂單總覽</router-link>
        </div>
      </section>
      <div class="search_info">
        <div class="keyword_time">
          <span>查詢</span>
          <div class="keyword">
            <label for="keyword">關鍵字：</label>
            <input v-model="currentListInfo.keyword" v-on:keyup.enter="getSpecialMemberList(currentListInfo.status,currentListInfo.keyword,currentListInfo.page)" class="input_keyword" placeholder="訂單編號、收件人、電話、地址" type="text" name="" value="">
          </div>
        </div>
        <div class="order_status">
          <div class="order orderStatus" :class="{'active-status':currentListInfo.status === '1'}" @click="getSpecialMemberList('1',currentListInfo.keyword,currentListInfo.page)">所有特約</div>
          <div class="order orderStatus" :class="{'active-status':currentListInfo.status === '0'}" @click="getSpecialMemberList('0',currentListInfo.keyword,currentListInfo.page)">申請中</div>
          <div class="number_of_order order">
            <span class="previous" :class="{'page-disable':isLastPage}">&#8249;</span>
            <span class="nextPage" :class="{'page-disable':isLastPage}">&#8250;</span>
          </div>
        </div>
      </div>
  		<div class="container-table">
        <table>
          <thead>
            <tr class="order_title">
              <th>公司/機構名稱</th>
              <th>公司/聯絡地址</th>
              <th>負責人名稱</th>
              <th>負責人電話</th>
              <th>電子信箱</th>
              <th>LINE ID</th>
              <th>刪除</th>
            </tr>
          </thead>
          <div class="load" v-if="isLoading">
            <div class="line"></div>
            <div class="line"></div>
            <div class="line"></div>
          </div>
          <div class="" v-else-if="this.memberListData.length === 0">
            無特約商資料供顯示
          </div>
          <tbody v-else>
            <tr class="order_info" v-for="member in this.memberListData" :key="member.id">
              <td>{{member.company_company_name}}</td>
              <td>{{member.company_address_county+member.company_address}}</td>
              <td>{{member.principal_name}}</td>
              <td>{{member.principal_phone}}</td>
              <td>{{member.principal_email}}</td>
              <td>{{member.principal_line_id}}<button class="btn-applyPass" v-if="currentListInfo.status === '0'" @click="applyPass(member.id,member.principal_name)">申請通過</button></td>
              <td class="delete" @click="deleteMember(member.id,member.principal_name)">&#10005;</td>
            </tr>
          </tbody>
        </table>
  		</div>
    </div>
  </div>
</template>

<script>
import AdminHeader from "@/components/admin/admin_header.vue";
import Datepicker from "vuejs-datepicker";
import "@/scss/_datepicker_plugin.scss";

export default {
  name: "adminSpecialMemberList",
  components: {
    AdminHeader,
    Datepicker
  },
  data() {
    return {
      icon: "fa fa-calendar",
      currentListInfo: {
        status: "0",
        keyword: "",
        page: "1"
      },
      memberListData: [],
      paginationData: "",
      isLoading: false
    };
  },
  created() {
    this.getSpecialMemberList(
      this.currentListInfo.status,
      this.currentListInfo.keyword,
      this.currentListInfo.page
    );
  },
  methods: {
    async getSpecialMemberList(status, keyword, page) {
      this.isLoading = true;
      this.currentListInfo = { status, keyword, page };
      try {
        let list = await this.$store.dispatch(
          "getSpecialMemberList",
          this.currentListInfo
        );
        this.memberListData = list.data.items;
        this.paginationData = list.data.pagination;
        this.isLoading = false;
      } catch (e) {
        alert(`錯誤訊息：${e}，請重新檢查`);
      }
    },
    async applyPass(id, name) {
      let userResponse = confirm(`確定通過${name}的申請嗎？`);
      if (userResponse) {
        try {
          await this.$store.dispatch("specialMemberApplyPass", id);
          this.getSpecialMemberList(
            this.currentListInfo.status,
            this.currentListInfo.keyword,
            this.currentListInfo.page
          );
          alert("更新完成");
        } catch (e) {
          alert(`錯誤訊息：${e}，請重新檢查`);
        }
      }
    },
    async deleteMember(id, name) {
      let userResponse = confirm(`確定刪除${name}特約資料嗎？`);
      if (userResponse) {
        try {
          let res = await this.$store.dispatch("deleteSpecialMember", id);
          this.getSpecialMemberList(
            this.currentListInfo.status,
            this.currentListInfo.keyword,
            this.currentListInfo.page
          );
          alert("刪除成功");
        } catch (e) {
          alert(`錯誤訊息：${e}，請重新檢查`);
        }
      }
    }
  },
  computed: {
    isLastPage() {
      if ((this.currentListInfo.page = this.paginationData.lastPage)) {
        return true;
      } else {
        return false;
      }
    }
  }
};
</script>
<style scoped lang="scss">
* {
  font-size: 17px;
}
.admin-back {
  display: flex;
  align-items: center;
  height: 66px;
  margin: 0 30px;
  i {
    color: $secondaryDeepColor1;
    margin-right: 10px;
  }
  a {
    color: $secondaryDeepColor1;
  }
}
table {
  width: 100%;
}
table {
  border-collapse: collapse;
  border-top: 1px solid #ddd;
}

.order_status,
tr,
td {
  border-bottom: 1px solid #ddd;
  .previous,
  .nextPage {
    color: #333;
    font-size: 24px;
    padding: 0 10px;
  }
}
.search_info {
  background-color: #f7f7f8;
  border-bottom: 1px #ddd solid;
  border: #f7f7f8;
  .keyword_time {
    display: flex;
    align-items: center;
    padding: 20px 0;
    border-top: 1px #ddd solid;
    .input_keyword {
      height: 32px;
      width: 345px;
      border: 1px #ddd solid;
      padding: 5px;
    }
    .date {
      display: flex;
      align-items: center;
      padding-left: 30px;
    }
  }
  span {
    padding: 0 30px;
    font-weight: bold;
  }
  .btn-search {
    background-color: #4a90e2;
    color: #fff;
    width: 120px;
    height: 35px;
    border: 0;
    cursor: pointer;
    padding: 0;
    &:hover {
      background-color: darken(#4a90e2, 10%);
    }
  }
}
.order_status {
  display: flex;
  padding: 10px 0 0 0;
  color: #9b9b9b;
  .order {
    display: inline;
    cursor: pointer;
    padding: 10px 30px;
  }
  a {
    color: #4a4a4a;
    font-size: 24px;
    margin: 0 20px;
  }
  .number_of_order {
    margin-left: auto;
  }
}
.order_info {
  .btn-applyPass {
    margin-left: 60px;
    color: #4a4a4a;
    border: 1px #4a4a4a solid;
    border-radius: 2px;
    height: 35px;
    line-height: 35px;
    padding: 0 15px;
  }
}
tbody {
  tr:hover {
    background-color: #f7f7f8;
  }
}
.order_title,
.order_info {
  th,
  td {
    height: 70px;
    text-align: left;
  }
  th:first-child,
  td:first-child {
    padding-left: 30px;
  }
  .delete {
    color: red;
    cursor: pointer;
    &:hover {
      color: darken(red, 10%);
    }
  }
}

.active-status {
  // border:1px solid red;
  color: #4a4a4a;
  border-bottom: 3px #4a4a4a solid;
}
.page-disable {
  color: gray;
}
//loading
.load {
  display: flex;
  justify-content: center;
  align-items: center;
}
.load .line:nth-last-child(1) {
  animation: loadingC 0.6s 0.1s linear infinite;
}
.load .line:nth-last-child(2) {
  animation: loadingC 0.6s 0.2s linear infinite;
}
.load .line:nth-last-child(3) {
  animation: loadingC 0.6s 0.3s linear infinite;
}
.line {
  display: inline-block;
  width: 15px;
  height: 15px;
  margin: 3px;
  border-radius: 15px;
  background-color: #2275d7;
}
@keyframes loadingC {
  0 {
    transform: translate(0, 0);
  }
  50% {
    transform: translate(0, 15px);
  }
  100% {
    transform: translate(0, 0);
  }
}
</style>
